module.exports = __webpack_public_path__ + "assets/logo-icon-white.8f9e09d9.svg";